/*
  Farbgeschwister in der PDP-Thumbnailleiste.

  Handyhuellen liegen als ein Shopify-Produkt PRO FARBE vor (Printful
  synchronisiert hoechstens 100 Varianten je Produkt). Die Farbwahl auf der
  Produktseite ist deshalb eine Reihe von Links auf die Geschwisterprodukte
  (.swatch-row a.cswatch, gerendert von snippets/eyg-color-siblings.liquid).
  Dieses Skript haengt zu jedem Geschwisterprodukt eine Miniatur an die
  bestehende Leiste .pdp-thumbs, damit man die anderen Farben schon in der
  Galerie sieht und nicht erst nach einem Klick auf einen kleinen Farbpunkt.

  Der Groessentabellen-Link wurde frueher hier per JS umgezogen; das ist
  seit 2026-08-03 fest in sections/eyg-pdp-main.liquid eingebaut (Link steht
  dort im Passform-Block ueber der Beschreibung) und hier wieder entfernt.

  Die Miniaturen sind echte <a>-Elemente. Sie navigieren, sie tauschen NICHT
  das Buehnenbild, denn eine andere Farbe ist ein anderes Produkt mit eigenem
  Preis und eigener Variantenliste. Die eigenen Thumbnails (button.pdp-thumb)
  behalten ihr Verhalten unveraendert.
*/
(function () {
  function init() {
    var root = document.querySelector('.eyg-pdpx');
    if (!root || root.dataset.sibThumbs === '1') return;

    var row = root.querySelector('.swatch-row');
    var strip = root.querySelector('.pdp-thumbs');
    if (!row || !strip) return;

    var links = [].slice.call(row.querySelectorAll('a.cswatch[href]'));
    if (!links.length) return;
    root.dataset.sibThumbs = '1';

    injectStyles();

    var sep = document.createElement('span');
    sep.className = 'pdp-thumb-sep';
    sep.setAttribute('aria-hidden', 'true');
    strip.appendChild(sep);

    links.forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var handle = href.split('/products/')[1];
      if (!handle) return;
      handle = handle.split('?')[0].split('#')[0].replace(/\/$/, '');

      var label = link.getAttribute('title') || link.getAttribute('aria-label') || '';
      var color = link.style.backgroundColor || '';

      /* Platzhalter sofort einhaengen, damit die Reihenfolge der Farben
         erhalten bleibt, egal wie schnell die einzelnen Anfragen antworten. */
      var slot = document.createElement('a');
      slot.className = 'pdp-thumb pdp-thumb-sib';
      var eygT = window.eygT || {};
      var rootPath = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
      slot.href = rootPath + 'products/' + handle;
      slot.title = label ? (eygT.product_view_color || '{color} ansehen').replace('{color}', label) : (eygT.product_view_other_color || 'Andere Farbe ansehen');
      slot.setAttribute('aria-label', slot.title);
      slot.hidden = true;
      if (color) {
        var dot = document.createElement('span');
        dot.className = 'pdp-thumb-dot';
        dot.style.background = color;
        slot.appendChild(dot);
      }
      strip.appendChild(slot);

      fetch(rootPath + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var src = p.featured_image || (p.images && p.images[0]);
          if (!src) return;
          var img = document.createElement('img');
          img.src = sized(src, 200);
          img.alt = p.title || label;
          img.loading = 'lazy';
          img.draggable = false;
          slot.insertBefore(img, slot.firstChild);
          slot.hidden = false;
        })
        .catch(function () { /* eine fehlende Farbe darf die Galerie nicht kippen */ });
    });

    /* Trennstrich nur zeigen, wenn wirklich eine Miniatur ankam. */
    window.setTimeout(function () {
      if (!strip.querySelector('.pdp-thumb-sib:not([hidden])')) sep.remove();
    }, 4000);
  }

  function sized(url, w) {
    if (!url) return url;
    var clean = url.split('&width=')[0].split('?width=')[0];
    return clean + (clean.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function injectStyles() {
    if (document.getElementById('eyg-sib-thumb-css')) return;
    var css = [
      '.eyg-pdpx .pdp-thumb-sep{flex:0 0 auto;align-self:center;width:1px;height:34px;background:var(--edge,#C4AB95);opacity:.7;margin:0 .15rem;}',
      '.eyg-pdpx a.pdp-thumb-sib{position:relative;display:block;}',
      '.eyg-pdpx a.pdp-thumb-sib .pdp-thumb-dot{position:absolute;right:3px;bottom:3px;width:11px;height:11px;border-radius:50%;border:1.5px solid #fff;box-shadow:0 0 0 1px rgba(92,47,37,.25);z-index:2;}',
      '@media(hover:hover) and (pointer:fine){.eyg-pdpx a.pdp-thumb-sib:hover{border-color:var(--brown,#5C2F25);}}'
    ].join('');
    var tag = document.createElement('style');
    tag.id = 'eyg-sib-thumb-css';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
